<template>
  <v-card class="link-preview mb-4" elevation="1">
    <v-row align-content="center" no-gutters>
      <!-- <v-col cols="auto" align-self="center" class="pa-4 pt-2 pb-2 pr-0">
        <v-img max-width="106" max-height="80" :src="image()"></v-img>
      </v-col> -->

      <v-col cols="9" class="pa-4">
        <a @click="openUrl(previewObject)">
          <p class="body-1 my-1">
            {{ previewObject.url }}
          </p>
        </a>

        <!-- <p class="body-2 font-weight-light ma-0 ellipsis">
            {{ previewObject.description.substring(0, 50) }}
          </p> -->
      </v-col>
      <v-col
        cols="3"
        class="pa-4"
        style="display: flex; justify-content: flex-end"
      >
        <v-btn
          @click="openUrl(previewObject)"
          small
          elevation="0"
          class="mb-0 body-2 text-primary text-capitalize"
          color="white"
        >
          <v-icon left>mdi-launch</v-icon>Open
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  props: ["previewObject"],
  methods: {
    image() {
      console.log(this.previewObject);
      if (this.previewObject) {
        if (this.previewObject.image) {
          return this.previewObject.image;
        } else if (this.previewObject.images) {
          return this.previewObject.images[0];
        }
      }
    },
    openUrl(item) {
      if (item.url) {
        window.open(item.url, "_blank");
      }
    },
  },
};
</script>
<style scoped>
.text-primary {
  color: rgb(66, 154, 216) !important;
}
</style>
